import { createFileRoute } from '@tanstack/react-router';
import { BankAccountsListPage } from '@/features/holders/bank-accounts-list-page.js';

export const Route = createFileRoute('/_app/bank-accounts/')({
  component: BankAccountsListPage,
});
